import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateAdapter,MatSnackBar } from '@angular/material';
import { ValidationService } from '../../../application-validators/validation.service';
import { ApplicationService } from '@app/applications/application.service';
import { LoanApplication,ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { DateFormatPipe } from '@app/utils/date-format.pipe';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import { Documents } from '../../applicant/applicantDocuments/applicant-document.model';
@Component({
  selector: 'eng-list-of-doc',
  templateUrl: 'lod.template.html',
  styleUrls: ['../../application-details.styles.scss']
})
export class ListOfDocumentsComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
    menuCode:string;


  lodDocuments: Documents[];
  lodForm: FormGroup;
  selectedListOfDocument: Documents;

  isFormDisabled: boolean;
  showForm: boolean;
  allowAccess:Boolean;
  menuItemAllowAccess:boolean;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  // for date field we need to allow only past date and also we need to exclude today as well
  yesterday: Date;

  constructor(private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private dateAdapter: DateAdapter<Date>,
    private validationService: ValidationService,
    private confirmationDialogService: ConfirmationDialogService) {
    this.lodForm = this.formBuilder.group({
      docName: '',
      description: '',
      hardCopy:'',
      lodDate: '',
      documentNumber:'',
      documentDetails: '',
      remarks:''
    });
      this.dateAdapter.setLocale('en-IN');
    this.allowAccess = this.applicationService.allowAccess;
    let today = new Date();
    this.yesterday = new Date(today.setDate(today.getDate() - 1));
  }

  ngOnInit(): void {
    this.isFormDisabled = true;
    this.fetchListOfLod();
    this.getMenuItemAccess();
    this.applyValidatorsToLod();
  }


  fetchListOfLod() {
    this.showForm = false;
    this.applicationService.getListOfLod(this.application.uid).subscribe((response: any) => {
        if (response) {
          this.lodDocuments = response.body;
          this.lodDocuments.forEach((element, index) => {
            this.lodDocuments[index]["deleteBtnDisabled"] = true;
          });
          this.showForm = (this.lodDocuments && this.lodDocuments.length > 0);
          this.buildLodForm();
        }
      });
  }

  addNewLod() {
    this.showForm = true;
    this.lodDocuments.forEach((element,i) => {
      this.lodDocuments[i].deleteBtnDisabled = true;
    });
    this.buildLodForm(new Documents());
    this.isFormDisabled = false;
  }

  changeSelectedLod(postDateCheque?: Documents, index?: number) {
    this.showForm = true;
    this.lodDocuments.forEach((element, i) => {
      this.lodDocuments[i].deleteBtnDisabled = true;
    });
    this.lodDocuments[index].deleteBtnDisabled = false;
    this.buildLodForm(postDateCheque);
  }

  buildLodForm(lod?: Documents) {
    if (this.showForm) {
      if (!lod) {
        lod = this.lodDocuments[0];
        this.lodDocuments[0].deleteBtnDisabled = false;
      }
      this.lodForm.patchValue({
        docName: lod.documentName,
        description: lod.documentDescription,
        hardCopy: lod.hardCopy,
        lodDate: lod.documentDate === null || lod.documentDate === undefined ? undefined : new Date(lod.documentDate),
        documentNumber: lod.documentNumber,
        documentDetails: lod.documentDetails,
        remarks: lod.remarks
      });
      this.selectedListOfDocument = lod;
    }
  }

 
  saveLod() {
    this.validationService.markFormGroupTouched(this.lodForm)
    if (!this.isFormDisabled && this.lodForm.valid) {
      let lodFormFields = this.lodForm.value;
      this.selectedListOfDocument.documentName = lodFormFields.docName;
      this.selectedListOfDocument.documentDescription = lodFormFields.description;
      this.selectedListOfDocument.hardCopy = lodFormFields.hardCopy;
      this.selectedListOfDocument.documentDate = lodFormFields.lodDate;
      this.selectedListOfDocument.documentNumber = lodFormFields.documentNumber;
      this.selectedListOfDocument.documentDetails = lodFormFields.documentDetails;
      this.selectedListOfDocument.remarks = lodFormFields.remarks;
      this.applicationService.saveLod(this.application.uid,
        this.selectedListOfDocument.uid, this.selectedListOfDocument).toPromise().then((_success) => {
          this._snackbar.open("List of document updated successfully", "Close", {
            duration: 5000,
          });
          this.isFormDisabled = true;
          this.fetchListOfLod();
        }, (failure) => {
          let errormesg =[]
          errormesg.push("Post Date Cheque update failed")
          errormesg.push(failure)
          this.applicationService.displayErrorMessages(errormesg);
        }
        );
    }
  }

  enableDisableForm() {
    this.isFormDisabled = false;
  }

  cancelForm() {
    this.lodDocuments.forEach((element, i) => {
      this.lodDocuments[i].deleteBtnDisabled = true;
    });
    if (this.lodDocuments && this.lodDocuments.length > 0) {
      this.buildLodForm();
    } else {
      this.showForm = false;
    }
    this.isFormDisabled = true;
  }

  //this function will apply validators to form group
  applyValidatorsToLod() {
    this.validationService.applyValidationRules(this.lodForm, "ListOfDocuments").then((controlValidators) => {
      this.fetchListOfLod();
    }).catch(() => {
    })
  }


  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess(){
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
        .subscribe((response) => {
          this.applicationAccessSpecifiers = response.body;
          this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
            .find(accessSpecifier => accessSpecifier.category === this.menuCode);
          if(this.menuItemAccessSpecifier){
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
            }
      });
    }


  openDeleteConfirmation() {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this LOD?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteLod(this.selectedListOfDocument)
      }
    })
  }

    //this function will be called on click of delete icon
    deleteLod(selectedListOfDocument) {
      this.applicationService.lodDelete(this.application.uid,selectedListOfDocument.uid).subscribe((response) => {
        if(response.body.status == "success") {
        this._snackbar.open(response.body.message , "Close", {
          duration: 5000,
        });
        this.fetchListOfLod()
      } else {
        let errormesg = []
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }}, (failure) => {
        let errormesg = []
        errormesg.push(failure)
        this.applicationService.displayErrorMessages(errormesg);
      });
    }


}